module.exports = __webpack_public_path__ + "static/media/DqEveryChildOfflineTradingCards.f0bafe58.jpg";